<template>
	<div class="visibility-dropdown">
		<DropdownWithIcons
			:value="selectedVisibilityOption"
			:options="options"
			:is-small="true"
			:disabled="disabled"
			@input="onChange"
		/>
	</div>
</template>

<script>
import VisibilityIconMixin from '@videotools/js/mixins/visibility-icon';
import { ALL_VISIBILITIES, VISIBILITY_CONTEXT, VISIBILITY_PUBLIC } from '@videotools/js/api/entities/TagGroup';
import DropdownWithIcons from '@components/dropdown/DropdownWithIcons';
import { mapGetters } from 'vuex';

export default {
	name:       'VisibilityDropdown',
	components: { DropdownWithIcons },
	mixins:     [VisibilityIconMixin],
	props:      {
		disabled: {
			type:    Boolean,
			default: false,
		},
		value: {
			default: null,
		},
	},
	computed: {
		...mapGetters({
			contextName: 'user/contextName',
		}),
		options() {
			return ALL_VISIBILITIES.map(v => {
				const label = v === VISIBILITY_CONTEXT
					? this.transUcfirst(`tag_group.visibilities.${v}.${this.contextName}`)
					: this.transUcfirst(`tag_group.visibilities.${v}`);

				return {
					label,
					id:       v,
					value:    v,
					icon:     this.visibilityIcon(v),
					disabled: v === VISIBILITY_PUBLIC,
				};
			});
		},
		selectedVisibilityOption() {
			return this.options.find(o => o.id === this.value);
		},
	},
	methods: {
		onChange(val) {
			this.$emit('input', val);
		},
	},
};
</script>

<style lang="scss" scoped>

.visibility-dropdown {
	min-width: 204px;
}

.selected-item {
	display: flex;
	align-items: center;
	flex: 1;

	.value-label {
		flex-shrink: 1;
		margin-right: 8px;
	}
}

::v-deep ul.dropdown-list li {
	padding-right: 12px;
}
</style>
